import Notification from "./Notification";

// Initialise notification components
const notificationElems = document.querySelectorAll(Notification.identifier);
notificationElems.forEach((notification) => {
  new Notification({
    element: notification,
    theme: "sand",
  });
});

// Test function for adding a notification
/*(function () {
  setTimeout(() => {
    const config = {
      content:
        "This is a notification testing dynamic rendering of a new notification",
      active: true,
      theme: "sand",
      toFront: true,
      forBookmark: true,
    };

    new Notification(config);
  }, 3000);
})();*/
